angular.module('impactx.rfx').service('RFXSupplierService', [
    '$mdDialog',
    'dataGen',
    'OutsourcedCommentSaveService',
    '$q',
    'TranslationService',
    '$errorHandler',
    RFXSupplierService
]);

function RFXSupplierService($mdDialog, dataGen, OutsourcedCommentSaveService, $q, TranslationService, $errorHandler) {

    function showContractOrLotSelectionDialog(event, baseItem, rfqsId, trns) {
        return $mdDialog.show({
            controller: 'RFXSupplierContractSelectionCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-contract-selection.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                rfqsId: rfqsId,
                lot: baseItem.lot,
                contract: baseItem.contract,
                trns: trns
            }
        });
    }

    function getSmartFormPolicy(id, smartFormPolicies) {
        var policies = smartFormPolicies;
        if (typeof id === 'string') {
            for (var key in policies) {
                if (policies.hasOwnProperty(key) &&
                    policies[key].identifier === id) {
                    return policies[key];
                }
            }
        }
        else if (typeof id === 'number' && !isNaN(id)) {
            return policies[id];
        }
    }

    function showEditFreeformDialog(event, itemCopy, trns, rfqsId, showGross) {
        return $mdDialog.show({
            templateUrl: "modules/rfxsupplier/templates/rfx-supplier-edit-item.dialog.html",
            controller: "RFXSupplierEditItemCtrl",
            controllerAs: "rfxItemCtrl",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: trns,
                item: itemCopy,
                rfqsId: rfqsId,
                showGross: showGross
            }
        }).then(function (item) {
            if (item) {
                // update the gross
                return updateItem(item, rfqsId);
            }
        });
    }

    function showFreeformOfferDialog(ev, basketItemGroupId, headerId, supplierId, items, groupData, cscId, lotId, readOnly, contracts) {
        return $mdDialog.show({
            controller: "RfxEditFreeFormOfferCtrl",
            controllerAs: "editFreeFormOfferCtrl",
            templateUrl: 'modules/rfx/templates/rfx-freeformofferdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                basketItemGroupId: basketItemGroupId ? basketItemGroupId : 0,
                headerId: headerId,
                supplierId: supplierId,
                items: items,
                groupData: groupData,
                lotId: lotId || 0,
                cscId: cscId || 0,
                readOnly: !!readOnly,
                contracts: contracts
            }
        });
    }

    function showConditionDialogData(ev, conditionItem, trns, baseItemTax, cscId) {
        return $mdDialog.show({
            controller: "RfxEditConditionDialogCtrl",
            controllerAs: "ctrl",
            templateUrl: 'modules/rfxsupplier/templates/rfx-conditionitem.dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            bindToController: true,
            locals: {
                conditionItem: conditionItem,
                trns: trns,
                baseItemTax: baseItemTax,
                cscId: cscId
            }
        });
    }

    function updateItem(item, rfqsId) {
        cacheItemComments(item);
        return dataGen.postAsForm({}, {item: item, rfqsId: rfqsId}, "/rfx/supplier/updateditemprice");
    }

    function updateItemList(items, rfqsId) {
        cacheItemListComments(items)
        return dataGen.postAsForm({}, {items: items, rfqsId: rfqsId}, "/rfx/supplier/updatedallitemprice")
    }

    function cancelRequest(data) {
        var dataObj = {
            data: data
        };

        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/cancel");
    }

    var COMMENT_CACHE = {};
    function cacheItemComments(source, useCommentTable) {
        // there can only be external comments on items
        if (impactX.isDefined(source, 'comments.externalComments.newComments')) {
            var newComments = source.comments.externalComments.newComments;
            if (newComments && newComments.length > 0) {
                var token = source.comments.externalComments.commentToken;
                source.comments.externalComments.newComments = [];
                COMMENT_CACHE[token] = {newComments: newComments, useCommentTable: !!useCommentTable};
            }
        }
        if (source.basketItemGroupData) {
            cacheItemComments(source.basketItemGroupData, true);
        }
    }

    function cacheItemListComments(itemList) {
        if (itemList) {
            angular.forEach(itemList, function (item) {
                cacheItemComments(item);
            });
        }
    }

    function restoreItemComments(source) {
        if (impactX.isDefined(source, 'comments.externalComments')) {
            var token = source.comments.externalComments.commentToken;
            if (COMMENT_CACHE.hasOwnProperty(token)) {
                source.comments.externalComments.newComments = COMMENT_CACHE[token].newComments;
                delete COMMENT_CACHE[token];
            }

        }
        if (source.basketItemGroupData) {
            restoreItemComments(source.basketItemGroupData);
        }
    }

    function restoreItemListComments(itemList) {
        if (itemList) {
            angular.forEach(itemList, function (item) {
                restoreItemComments(item);
            });
        }
    }

    function saveItemComments(newTokenMap) {
        var defer = $q.defer();
        if (newTokenMap) {
            var tokens = Object.getOwnPropertyNames(COMMENT_CACHE);
            saveOneItemCommentAndCallNext(tokens, 0, newTokenMap, defer);
        }
        return defer.promise;
    }

    function saveOneItemCommentAndCallNext(tokens, iterator, newTokenMap, defer){
        if (tokens.length > iterator) {
            var token = tokens[iterator];
            if (newTokenMap.hasOwnProperty(token)) {
                OutsourcedCommentSaveService.saveCommentsByToken(newTokenMap[token],
                    COMMENT_CACHE[token].newComments, COMMENT_CACHE[token].useCommentTable).then(function () {
                    iterator++;
                    saveOneItemCommentAndCallNext(tokens, iterator, newTokenMap, defer)
                }, function () {
                    COMMENT_CACHE = {};
                    defer.reject();
                })
            }
        }
        else {
            COMMENT_CACHE = {};
            defer.resolve();
        }

    }

    function saveItemCommentsEncrypted(rfqsId) {
        var defer = $q.defer();
        var tokens = Object.getOwnPropertyNames(COMMENT_CACHE);
        saveItemCommentsEncryptedAndCallNext(rfqsId, tokens, 0, defer);
        return defer.promise;
    }

    function saveItemCommentsEncryptedAndCallNext(rfqsId, tokenlist, tokenIterator, defer) {
        if (tokenIterator < tokenlist.length) {
            var token = tokenlist[tokenIterator];
            var commentObj = COMMENT_CACHE[token]
            saveOneItemCommentEncrypted(rfqsId, token, commentObj.newComments).then(function () {
                tokenIterator++;
                saveItemCommentsEncryptedAndCallNext(rfqsId, tokenlist, tokenIterator, defer);
            }, function () {
                defer.reject();
            });
        }
        else {
            COMMENT_CACHE = {};
            defer.resolve();
        }
    }

    function saveOneItemCommentEncrypted(rfqsId, token, commentList) {
        var defer = $q.defer();
        saveOneItemCommentEncryptedAndCallNext(rfqsId, token, commentList, 0, defer);
        return defer.promise;
    }

    function saveOneItemCommentEncryptedAndCallNext(rfqsId, token, commentList, commentIterator, defer) {
        if (commentIterator < commentList.length) {
            if (commentList[commentIterator] && commentList[commentIterator].attachments &&
                commentList[commentIterator].attachments.newEntries &&
                commentList[commentIterator].attachments.newEntries[0]) {
                var file = commentList[commentIterator].attachments.newEntries[0].file;
                if (file) {
                    var fileData = {
                        file: file,
                        fileName: file.name,
                        commentToken: token,
                        rfqsId: rfqsId
                    };
                    dataGen.uploadFile(fileData, '/rfx/encryptattachments').then(function () {
                        commentIterator++;
                        saveOneItemCommentEncryptedAndCallNext(rfqsId, token, commentList, commentIterator, defer);
                    }, function () {
                        defer.reject();
                    });
                }
                else {
                    commentIterator++;
                    saveOneItemCommentEncryptedAndCallNext(rfqsId, token, commentList, commentIterator, defer);
                }
            }
            else {
                commentIterator++;
                saveOneItemCommentEncryptedAndCallNext(rfqsId, token, commentList, commentIterator, defer);
            }
        }
        else {
            defer.resolve();
        }
    }

    function showTermsDialog(event, rfqsId, termsText, termsAttachments, trns) {
        return $mdDialog.show({
            controller: 'RFXSupplierTermsDialogCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-terms-dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                rfqsId: rfqsId,
                termsText: termsText,
                termsAttachments: termsAttachments,
                trns: trns
            }
        });
    }

    function addItemToContracts(item, selectedCSC, selectedLot, data, saveHeader, form, sendErrorList, outlet) {
        if (!data) {
            $errorHandler.showErrors([{error: TranslationService.get('rfxNoDataFoundBecauseOfReload')}]);
            return $q.reject();
        }
        var cscId = impactX.isDefined(selectedCSC, 'selected.id');
        var lotId = impactX.isDefined(selectedLot, 'selected.id');
        var itemCscId = impactX.isDefined(item, 'csc.id');
        var itemLotId = impactX.isDefined(item, 'lot.id');
        var outletId = impactX.isDefined(outlet, 'selected.id');

        var foundContract = findContract(item, selectedCSC, selectedLot, data);

        if (foundContract) {
            foundContract.items.push(item);
        }
        else if (cscId || lotId) {
            foundContract = {
                cscId: cscId ? cscId : 0,
                lotId: lotId ? lotId : 0,
                items: [item]
            }
        }
        else if (itemCscId || itemLotId) {
            foundContract = {
                cscId: itemCscId,
                lotId: itemLotId,
                items: [item]
            }
        }
        else if (!itemCscId && !itemLotId) {
            foundContract = {
                cscId: 0,
                lotId: 0,
                items: [item]
            }
        }
        if (foundContract && outletId) {
            foundContract.outletId = outletId ? outletId : 0
        }
        return updateContract(foundContract, null, null, data, saveHeader, form, sendErrorList);
    }

    function findContract(item, selectedCSC, selectedLot, data) {
        var cscId = impactX.isDefined(selectedCSC, 'selected.id');
        var lotId = impactX.isDefined(selectedLot, 'selected.id');
        var itemCscId = impactX.isDefined(item, 'csc.id');
        var itemLotId = impactX.isDefined(item, 'lot.id');

        var foundContract = undefined;
        angular.forEach(data.contracts, function (contract) {
            if (cscId || lotId) {
                if (cscId === contract.id || lotId === contract.lotId) {
                    foundContract = contract;
                }
            }
            else if (itemCscId === contract.id || (!itemCscId && contract.id === 0) || itemLotId === contract.lotId) {
                foundContract = contract;
            }
        });
        return foundContract;
    }

    function updateContract(contract, item, itemChangedContract, data, saveHeader, form, sendErrorList) {
        if (contract) {
            if (itemChangedContract) {
                addItemToContracts(item);
            }
            var requestData = {
                rfqsId: data.id,
                cscId: contract.cscId ? contract.cscId : contract.id,
                lotId: contract.lotId,
                items: contract.items,
                outletId: contract.outletId ? contract.outletId : 0
            }

            cacheItemListComments(contract.items);
            return dataGen.postAsForm({}, requestData, '/rfx/supplier/contract/update').then(function (response) {

                if (response.data) {
                    if (contract.name || contract.id === 0) {
                        contract.name = response.data.name;
                        contract.totalValue = response.data.totalValue;
                        contract.currency = response.data.currency;
                        if (contract.outletId) {
                            contract.outlet = response.data.outlet;
                        }
                        restoreItemListComments(contract.items);
                    }
                    else {
                        restoreItemListComments(response.data.items);
                        data.contracts.push(response.data);
                    }

                    updateSupplierHeaderSum(false, data, form, sendErrorList);
                    if (saveHeader) {
                        saveRequest(data).then(function() {
                            return response.data;
                        })
                    }
                    else {
                        return response.data;
                    }
                }
            });
        }
    }

    function updateSupplierHeaderSum(inititalGet, data, form, sendErrorList) {
        checkErrors(sendErrorList, data);
        var hasItems = false;
        if (data.contracts) {
            for (var i = 0; i < data.contracts.length; i++) {
                if (data.contracts[i].items.length > 0) {
                    hasItems = true;
                    break;
                }
            }
        }
        data.hasItems = hasItems;
        var requestData = {
            contracts: data.contracts
        }
        cacheAllItemComments(data);
        dataGen.postAsForm({}, requestData, '/rfx/supplier/sum/update').then(function (response) {
            restoreAllItemComments(data);
            if (response.data) {
                data.sum = response.data;
            }
        }, function () {
            restoreAllItemComments(data);
        });
        if (!inititalGet && form) {
            form.$setDirty();
        }
    }

    function cacheAllItemComments(data) {
        angular.forEach(data.contracts, function (contract) {
            cacheItemListComments(contract.items);
        });
    }

    function restoreAllItemComments(data) {
        angular.forEach(data.contracts, function (contract) {
            restoreItemListComments(contract.items);
        });
    }

    function saveRequest(data) {
        var dataObj = {
            data: data
        };
        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/save").then(function (response) {
            if (response.data && response.data.saveAttachmentsEncrypted) {
                saveItemCommentsEncrypted(data.id);
            }
            else if (impactX.isDefined(response, "data.tokens")) {
                saveItemComments(response.data.tokens);
            }
        });
    }

    function checkErrors(sendErrorList, data) {
        if (sendErrorList) {
            sendErrorList.list = [];
            var foundItem = false;
            angular.forEach(data.contracts, function (contract) {
                if (contract.items && contract.items.length > 0) {
                    foundItem = true;
                }
            });
            if (!foundItem) {
                sendErrorList.list.push(TranslationService.get('noSendWithoutPosition'));
            }
        }
    }

    return {
        getSmartFormPolicy: getSmartFormPolicy,
        showEditFreeformDialog: showEditFreeformDialog,
        updateItem: updateItem,
        updateItemList: updateItemList,
        showContractOrLotSelectionDialog: showContractOrLotSelectionDialog,
        showFreeformOfferDialog: showFreeformOfferDialog,
        cancelRequest: cancelRequest,
        cacheItemComments: cacheItemComments,
        cacheItemListComments: cacheItemListComments,
        restoreItemComments: restoreItemComments,
        restoreItemListComments: restoreItemListComments,
        saveItemComments: saveItemComments,
        saveItemCommentsEncrypted: saveItemCommentsEncrypted,
        showConditionDialogData: showConditionDialogData,
        showTermsDialog: showTermsDialog,
        updateSupplierHeaderSum: updateSupplierHeaderSum,
        updateContract: updateContract,
        addItemToContracts: addItemToContracts,
        checkErrors: checkErrors,
        findContract: findContract
    };
}